import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SystemService } from '../../services/system.service';

@Injectable({
  providedIn: 'root'
})
export class LocalizationService {

  constructor(private http: HttpClient, private system: SystemService) { }

  getLocalization(): Observable<any[]> {
    return this.http.get<any[]>(this.system.apiURL + "/settings/localizations");
  }

  addLocalization(localization: any): Observable<any> {
    return this.http.post<any>(this.system.apiURL + "/settings/localizations", localization);
  }

  updateLocalization(localization: any): Observable<any> {
    const url = `${this.system.apiURL + "/settings/localizations"}/${localization.id}`;
    return this.http.put<any>(url, localization);
  }

  deleteLocalization(id: number): Observable<void> {
    const url = `${this.system.apiURL + "/settings/localizations"}/${id}`;
    return this.http.delete<void>(url);
  }
}
